// extracted by mini-css-extract-plugin
module.exports = {"title":"SendQuoteSectionIntro_title__ARZz_","body":"SendQuoteSectionIntro_body__c0bmF"};